import React, { FC } from 'react';
import { useLocalizationContext } from '../../lib/localization';

export interface LocaleProps {
    localizationKey: string;
    params?: (string | number)[];
}

export const Locale: FC<LocaleProps> = ({ localizationKey, params = [] }) => {
    const { localizationService } = useLocalizationContext();

    return <>{localizationService.get(localizationKey, params)}</>;
};
